// extracted by mini-css-extract-plugin
export default {"iconSmall":"iconSmall__Jbp2X","iconMedium":"iconMedium__KtWak"};